import { useSelector } from 'react-redux';
import { ArtificialIntelligenceIcon } from 'foundations-assets';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { DefaultReportDescription } from 'reporting-ui-components/components/reportDescription/DefaultReportDescription';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../selectors/aiSettingsSelector';
import { Flex } from 'foundations-components/components/Flex';
import TruncateToRowLimit from 'reporting-discover-components/components/shared/TruncateToRowLimit';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GeneratedByAILegalText = () => /*#__PURE__*/_jsxs(Small, {
  marginBlockEnd: "0",
  marginBlockStart: "300",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportDescription.breezeGeneratedLegalText"
  }), /*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {})]
});
export const ReportDescription = ({
  report,
  truncate = false
}) => {
  const isGenerativeAiEnabled = useSelector(selectGenerativeAIEnabled);
  const description = report.get('description');
  const Description = description || /*#__PURE__*/_jsx(DefaultReportDescription, {
    report: report,
    isCustomerAnalysisEnabled: isGenerativeAiEnabled
  });
  if (truncate) {
    return /*#__PURE__*/_jsxs(TruncateToRowLimit, {
      rowLimit: 2,
      children: [Description, report.get('aiGeneratedDescription') && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(GeneratedByAILegalText, {})
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [Description, report.get('aiGeneratedDescription') && /*#__PURE__*/_jsx(GeneratedByAILegalText, {})]
  });
};